import script from "./DiagnosisSelectionPreviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosisSelectionPreviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosisSelectionPreviewComponent.vue?vue&type=style&index=0&id=6eea6abe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eea6abe"]])

export default __exports__